exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".skip-icon[data-v-02d80264]{position:relative;width:22px;height:32px;display:inline-block}.skip-icon .icon1[data-v-02d80264]{height:30px;left:0;top:0;width:20px}.skip-icon .icon1[data-v-02d80264],.skip-icon .icon2[data-v-02d80264]{position:absolute;-webkit-transform-origin:0 0;transform-origin:0 0}.skip-icon .icon2[data-v-02d80264]{height:16px;left:4px;top:5px;width:17px}", ""]);

// exports
